import { useLocation } from "react-router";

export const usePageModalLocationState = () => {
  const location = useLocation();

  return location.state?.pageModal ?? {};
};
